import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonTitle: 'Ok, I got it',
});
